/* eslint-disable no-unused-vars */
var DATA_STATE_CLEAN = "C",
    DATA_STATE_DIRTY = "D",
    DATA_STATE_POSTED = "P",

    ASCII_QUESTION = 63,
    ASCII_TILDA = 126,
    ASCII_BANG = 33,
    ASCII_PIPE = 124,
    ASCII_SHIFT_IN = 15,
    ASCII_0 = 48,
    ASCII_1 = 49,
    ASCII_2 = 50,
    ASCII_3 = 51,
    ASCII_4 = 52,
    ASCII_5 = 53,
    ASCII_6 = 54,
    ASCII_7 = 55,
    ASCII_8 = 56,
    ASCII_D = 68,

    RESULT_UNKNOWN = "unknown",

    EXIT_ACTION_EXIT_NO_CONFIRMATION = "exit,no confirmation",
    EXIT_ACTION_EXIT_CONFIRMATION = "exit,confirmation",
    EXIT_ACTION_GO_TO_NEXT_SCO = "continue",
    EXIT_ACTION_DISPLAY_MESSAGE = "message page",
    EXIT_ACTION_DO_NOTHING = "do nothing",
    EXIT_ACTION_REFRESH_PAGE = "refresh page",

    POSSIBLE_NAVIGATION_REQUEST_INDEX_START = 0,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_RESUME_ALL = 1,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE = 2,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS = 3,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT = 4,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL = 5,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_SUSPEND_ALL = 6,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON = 7,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_ABANDON_ALL = 8,
    POSSIBLE_NAVIGATION_REQUEST_INDEX_CHOICE = 9,

    LAUNCH_TYPE_FRAMESET = "frameset",
    LAUNCH_TYPE_POPUP = "new window",
    LAUNCH_TYPE_POPUP_AFTER_CLICK = "new window,after click",
    LAUNCH_TYPE_POPUP_WITHOUT_BROWSER_TOOLBAR = "new window without browser toolbar",
    LAUNCH_TYPE_POPUP_AFTER_CLICK_WITHOUT_BROWSER_TOOLBAR = "new window,after click,without browser toolbar",
    // for debugging only, not a user-facing option
    LAUNCH_TYPE_POPUP_WITH_MENU = "new window with menubar",

    STANDARD_SCORM_11 = "SCORM 1.1",
    STANDARD_SCORM_12 = "SCORM 1.2",
    STANDARD_SCORM_2004_2ND_EDITION = "SCORM 2004 2nd Edition",
    STANDARD_SCORM_2004_3RD_EDITION = "SCORM 2004 3rd Edition",
    STANDARD_SCORM_2004_4TH_EDITION = "SCORM 2004 4th Edition",
    STANDARD_AICC = "AICC",
    STANDARD_CMI5 = "cmi5",
    STANDARD_TINCAN = "Tin Can",
    STANDARD_LTI11 = "LTI 1.1",
    STANDARD_LTI13 = "LTI 1.3",

    // legacy names
    SCORM_2004_2ND_EDITION = "SCORM 2004 2nd Edition",
    STANDARD_SCORM_2004 = "SCORM 2004 3rd Edition",

    SCORM_TYPE_SCO = "SCO",
    SCORM_TYPE_ASSET = "Asset",
    SCORM_TYPE_OBJECTIVE = "Objective",
    SCORM_TYPE_AGGREGATION = "Aggregation",

    STATUS_DISPLAY_SUCCESS_ONLY = "success only",
    STATUS_DISPLAY_COMPLETION_ONLY = "completion only",
    STATUS_DISPLAY_SEPERATE = "separate",
    STATUS_DISPLAY_COMBINED = "combined",
    STATUS_DISPLAY_NONE = "none",

    STATUS_ROLLUP_METHOD_STATUS_PROVIDED_BY_COURSE = "STATUS_PROVIDED_BY_COURSE",
    STATUS_ROLLUP_METHOD_COMPLETE_WHEN_ALL_UNITS_COMPLETE = "COMPLETE_WHEN_ALL_UNITS_COMPLETE",
    STATUS_ROLLUP_METHOD_COMPLETE_WHEN_ALL_UNITS_COMPLETE_AND_NOT_FAILED = "COMPLETE_WHEN_ALL_UNITS_COMPLETE_AND_NOT_FAILED",
    STATUS_ROLLUP_METHOD_COMPLETE_WHEN_THRESHOLD_SCORE_IS_MET = "COMPLETE_WHEN_THRESHOLD_SCORE_IS_MET",
    STATUS_ROLLUP_METHOD_COMPLETE_WHEN_ALL_UNITS_COMPLETE_AND_THRESHOLD_SCORE_IS_MET = "COMPLETE_WHEN_ALL_UNITS_COMPLETE_AND_THRESHOLD_SCORE_IS_MET",
    STATUS_ROLLUP_METHOD_COMPLETE_WHEN_ALL_UNITS_ARE_PASSED = "COMPLETE_WHEN_ALL_UNITS_ARE_PASSED",

    SCORE_ROLLUP_METHOD_SCORE_PROVIDED_BY_COURSE = "SCORE_PROVIDED_BY_COURSE",
    SCORE_ROLLUP_METHOD_AVERAGE_SCORE_OF_ALL_UNITS = "AVERAGE_SCORE_OF_ALL_UNITS",
    SCORE_ROLLUP_METHOD_AVERAGE_SCORE_OF_ALL_UNITS_WITH_SCORES = "AVERAGE_SCORE_OF_ALL_UNITS_WITH_SCORES",
    SCORE_ROLLUP_METHOD_FIXED_AVERAGE = "FIXED_AVERAGE",
    SCORE_ROLLUP_METHOD_AVERAGE_SCORE_OF_ALL_UNITS_WITH_NONZERO_SCORES = "AVERAGE_SCORE_OF_ALL_UNITS_WITH_NONZERO_SCORES",
    SCORE_ROLLUP_METHOD_LAST_SCO_SCORE = "LAST_SCO_SCORE",

    RESET_RT_DATA_TIMING_NEVER = "never",
    RESET_RT_DATA_TIMING_WHEN_EXIT_IS_NOT_SUSPEND = "when exit is not suspend",
    RESET_RT_DATA_TIMING_ON_EACH_NEW_SEQUENCING_ATTEMPT = "on each new sequencing attempt",

    INVALID_MENU_ITEM_ACTION_DISABLE = "Disable",
    INVALID_MENU_ITEM_ACTION_HIDE = "Hide",
    INVALID_MENU_ITEM_ACTION_SHOW_ENABLE = "Show",

    LOOKAHEAD_SEQUENCER_MODE_DISABLE = "DISABLED",
    LOOKAHEAD_SEQUENCER_MODE_ENABLE = "ENABLED",
    LOOKAHEAD_SEQUENCER_MODE_REALTIME = "REALTIME",

    COMMIT_SAVE_ON_COMPLETION_NOT_SET = "not-set",
    COMMIT_SAVE_ON_COMPLETION_SET = "set",
    COMMIT_SAVE_ON_COMPLETION_SAVED = "saved",

    HASH_ALL_SCOS = -1;
